import React from "react";
import "./style.css";
import { Link } from "react-router-dom";
import { HiOutlineShoppingBag } from "react-icons/hi";

function Header({ ads }) {
  // const scrollAmount = 500;

  // const handleScroll = () => {
  //   window.scrollBy({
  //     top: scrollAmount,
  //     behavior: "smooth",
  //   });
  // };
  const ad = ads.length > 0 ? ads[0] : null;

  // Set background image only if an ad is available
  const headerStyle = ad ? { backgroundImage: `url(${ad.img_url})` } : {};

  return (
    <section id="hero" style={headerStyle}>
      {ad ? (
        <>
          <h1>
            City Gamers <span style={{ fontSize: "30px" }}>&</span>
          </h1>
          <h2>
            Electronics World <span className="dot">.</span>
          </h2>
          <p>{ad.sub_title}</p>
          {/* <button className="buttonShop">
            {" "}
            Shop Now <HiOutlineShoppingBag style={{ fontSize: "20px" }} />
          </button> */}
          <Link className="buttonShop" to="/ProductLayout">
            {" "}
            Shop Now <HiOutlineShoppingBag style={{ fontSize: "20px" }} />
          </Link>
        </>
      ) : (
        <p>No banner ads available</p>
      )}
    </section>
  );
}

export default Header;
